<template>
    <default-template>
        <v-layout class="fill-height justify-center align-start background-content">
            <v-responsive width="100%" max-width="1200" class="py-8" :class="{ 'px-4': $vuetify.breakpoint.mobile }">
                <v-layout>
                    <v-flex v-if="!$vuetify.breakpoint.mobile" shrink>
                        <v-card width="260" flat color="primary" class="white--text" elevation="0" tile>
                            <v-card-title>
                                <span>마이페이지</span>
                            </v-card-title>
                            <v-list>
                                <v-list-item-group mandatory>
                                    <v-list-item dense to="/member/profile">
                                        <v-list-item-title>회원정보수정</v-list-item-title>
                                    </v-list-item>
                                    <!-- <v-list-item dense to="/member/shop/carts">
                                        <v-list-item-title>장바구니</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item dense to="/member/shop/purchases">
                                        <v-list-item-title>주문배송조회</v-list-item-title>
                                    </v-list-item> -->
                                    <v-list-item dense to="/member/gshop/orders">
                                        <v-list-item-title>상품권 구매내역</v-list-item-title>
                                    </v-list-item>
                                    <!-- <v-list-item dense to="/member/cashes/inquiry">
                                        <v-list-item-title>캐시내역</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item dense to="/member/cashes/give">
                                        <v-list-item-title>캐시선물하기</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item dense to="/member/cashes/gift">
                                        <v-list-item-title>캐시선물내역</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item dense to="/member/cashes/charge">
                                        <v-list-item-title>캐시충전</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item dense to="/member/shop/gift-purchases">
                                        <v-list-item-title>도서 선물 내역조회</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item dense to="/member/points">
                                        <v-list-item-title>포인트 내역</v-list-item-title>
                                    </v-list-item> -->
                                </v-list-item-group>
                            </v-list>
                        </v-card>
                    </v-flex>
                    <v-flex shrink :class="{ 'pl-4': !$vuetify.breakpoint.mobile }" style="flex-grow: 1 !important;">
                        <slot />
                    </v-flex>
                </v-layout>
            </v-responsive>
        </v-layout>
    </default-template>
</template>
<script>
import DefaultTemplate from "../DefaultTemplate.vue";
export default {
    components: {
        DefaultTemplate,
    },
    created(){
        if(this.logoff) this.$router.push(`/login`);
    },
    computed: {
        accessToken(){
            return this.$store.state.accessToken;
        },
        logoff(){
            return !this.$store.state.accessToken;
        }
    },
}
</script>